/**
 * MobileHeaderActions — the desktop top bar's utilities, in the phone header
 * (audit 2026-11-02, #35): the theme switch, Guides (where the desktop frame
 * has them) and the notification bell with its unread count. The desktop
 * components themselves, so the count and the panels are the same ones.
 *
 * Left off on a phone, on purpose: the breadcrumb (the header's title and Back
 * do that job), the cycle context bar, the footer, the sync status dot and the
 * Co-Facilitator corner button (the tab bar owns the bottom edge).
 */
import { ThemeToggle } from '../components/ui/ThemeToggle';
import { NotificationBell } from '../components/prioritization/NotificationBell';
import { HarryHeaderActions } from '../components/harry/HarryHeaderActions';

interface MobileHeaderActionsProps {
  /** Draw the Guides button — only inside a HarryShell, as on the desktop Priorities frame. */
  guides?: boolean;
}

export function MobileHeaderActions({ guides = false }: MobileHeaderActionsProps) {
  return (
    <div className="flex flex-shrink-0 items-center gap-0.5">
      <ThemeToggle variant="icon" />
      {guides && <HarryHeaderActions />}
      <NotificationBell />
    </div>
  );
}
